import { render, staticRenderFns } from "./MappingPlayground.vue?vue&type=template&id=2c8c22ed&"
import script from "./MappingPlayground.vue?vue&type=script&lang=ts&"
export * from "./MappingPlayground.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports